import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import { replaceCamelCase } from './index';
export const unknownProp = null;
export const numericProp = [Number, String];
export const truthProp = {
  type: Boolean,
  default: true
};
export const makeRequiredProp = type => ({
  type,
  required: true
});
export const makeArrayProp = defaultVal => ({
  type: Array,
  default: () => defaultVal || []
});
export const makeNumberProp = defaultVal => ({
  type: Number,
  default: defaultVal
});
export const makeNumericProp = defaultVal => ({
  type: numericProp,
  default: defaultVal
});
export const makeStringProp = defaultVal => ({
  type: String,
  default: defaultVal
});
export const makeStringPropV2 = (enumVal, defaultVal) => ({
  type: String,
  default: defaultVal,
  validator: val => {
    var _context;
    return _includesInstanceProperty(_context = _Object$values(enumVal)).call(_context, val);
  }
});
export const definePropType = val => val;
export function getValidValue(values, type) {
  const validTypes = _Object$values(type);
  for (const value of values) {
    if (_includesInstanceProperty(validTypes).call(validTypes, value)) {
      return value;
    }
  }
  return values.at(-1);
}
const defaultSizeMap = {};

// 导出给后台组件库使用，参数格式为 setDefaultSizeMap({ button: 'large', dialog: 'middle' })
export const setDefaultSizeMap = sizeMap => {
  _Object$assign(defaultSizeMap, sizeMap);
};

// 如果组件名是多个单词，既支持中划线写法，又支持驼峰写法
export const getDefaultSize = (compName, defaultSize) => {
  return defaultSizeMap[compName] || defaultSizeMap[replaceCamelCase(compName)] || defaultSize;
};